import React, { useCallback } from 'react'
import { locationState } from '../context/location-context'
import LocationAutocompleteInput from './forms/location-autocomplete-input'

const AddressInput = ({ background }: { background?: string }) => {
  const { setSettings, settings } = locationState()
  const { address } = settings

  const changeAddress = useCallback(
    async (newAddress?: string) => {
      if (newAddress !== address) {
        await setSettings({ ...settings, address: newAddress })
      }
    },
    [address]
  )
  return (
    <LocationAutocompleteInput
      value={address}
      background={background}
      prompt="Your Full Address"
      onSelected={text => {
        changeAddress(text)
      }}
    />
  )
}
export default AddressInput
